export default __webpack_public_path__ + "static/media/pinkSquiggle.727a276e.png";